"use client";

import { SWRConfig } from "swr";
import { fetcher } from "@/lib/swr";

export function SWRProvider({ children }: { children: React.ReactNode }) {
  return (
    <SWRConfig
      value={{
        fetcher,
        dedupingInterval: 5000,
        revalidateOnFocus: false,
      }}
    >
      {children}
    </SWRConfig>
  );
}
